export default "__VITE_ASSET__fcm8R_VP__"